import Vue from "vue"
import Table from "./m-table"
import Paginator from "./m-paginator"
import Input from "./m-input"

document.addEventListener("DOMContentLoaded", () => {
  if (!document.getElementById("ordersList")) {
    return
  }

  window.companiesList = new Vue({
    el: "#ordersList",
    components: { "m-table": Table, "m-paginator": Paginator, minput: Input },
    data: {
      activePanel: "orders",
      headOrders: window.manager.data.headOrders,
      itemsOrders: window.manager.data.itemsOrders,
      headDrafts: window.manager.data.headDrafts,
      itemsDrafts: window.manager.data.itemsDrafts,
      currentPage: window.manager.data.currentPage,
      totalPages: window.manager.data.totalPages,
      search: "",
      companiesList: window.manager.data.companiesList,
      userList: window.manager.data.userList,
      blockedUsers: window.manager.data.blockedUsers,
      modalCreateOrder: false,
      createCompanyValue: null,
      createUserValue: null,
      isDeletedNow: false,
    },

    created() {
      this.createCompanyValue = Object.keys(this.companiesList)[0]
      this.createUserValue = Object.keys(this.userList)[0]
    },
    watch: {
      modalCreateOrder(isOpened) {
        if (isOpened) {
          this.onRevealModalOpened()
        } else {
          this.onRevealModelClosed()
        }
      },
      search(value) {
        const url = `${window.location}?search=${encodeURI(value)}`
        fetch(url, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.DATA) {
              this.items = data.DATA.items
            }
          })
      },
    },
    methods: {
      deleteOrders() {
        let candidates = this.$refs.orders.$children
        if (!candidates.length) {
          return false
        }

        let arDeleted = []
        candidates.forEach((item) => {
          if (item.internalValue === "Y") {
            arDeleted.push(item.$attrs["data-item"])
          }
        })
        if (arDeleted.length) {
          this.isDeletedNow = true
          const url = `${window.location}?delete=${encodeURI(arDeleted.toString())}`
          fetch(url, {
            headers: { "X-Requested-With": "XMLHttpRequest" },
          })
            .then((response) => response.json())
            .then((data) => {
              this.isDeletedNow = false
              if (!data.ERRORS && data.DATA) {
                this.itemsOrders = data.DATA.itemsOrders
                candidates.forEach((item) => {
                  item.internalValue = ""
                })
              }
            })
        }
      },
      /**
       * Обработчик собатия на открытие модалки
       */
      onRevealModalOpened() {
        $("html").addClass("is-reveal-open").addClass("zf-has-scroll")
      },
      /**
       * Обработчик события на закрытие модалки
       */
      onRevealModelClosed() {
        $("html").removeClass("is-reveal-open").removeClass("zf-has-scroll")
      },
      changePage(page) {
        this.current = page
        const url = `${window.location}?page=${encodeURI(page)}`
        fetch(url, {
          headers: { "X-Requested-With": "XMLHttpRequest" },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.DATA) {
              this.itemsOrders = data.DATA.itemsOrders
              this.currentPage = data.DATA.currentPage
              this.totalPages = data.DATA.totalPages
              this.$refs.paginator.buildChain()
            }
          })
      },
    },
  })
})
